
import Vue from 'vue'
import {ToastPlugin, PromptPlugin} from '@/components/hippius'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import router from './router'

import {setLocalValue} from '@/utils/commonUtil'
Vue.use(ToastPlugin)
Vue.use(PromptPlugin)
Vue.use(ConfirmPlugin)
export default {
name: 'App',
data () {
return {
routerAlive: true,
routerTransition: 'router-slide-left',
include: [],
network: true, // 默认有网
}
},
watch: {
$route (to, from) {
console.log('MMMM')
this.setStoreInfo('RouteStore', 'fromName', from.name)
const toDepth = to.path.split('/').length
const fromDepth = from.path.split('/').length
this.routerTransition =
toDepth < fromDepth ? 'router-slide-right' : 'router-slide-left'

if(to.meta.keepAlive) {
let toName = this.matchRoute(to.name)
!this.include.includes(toName) && this.include.push(toName)
}



if(from.meta.keepAlive && to.meta.depth < from.meta.depth) {
let fromName = this.matchRoute(from.name)
var index = this.include.indexOf(fromName)
index !== -1 && this.include.splice(index, 1)
}
console.log(this.include)
},
},
created () {
if(!window.navigator.onLine) {
Vue.$vux.confirm.show({
title: '提示',
content: '刷新',
showCancelButton: false,
showConfirmButton: false,
})
}
},
mounted () {

window.addEventListener('offline', () => {
console.log('已断网')
this.network = false

Vue.$vux.confirm.show({
title: '提示',
content: '网关超时，请检查网络连接',
showCancelButton: false,
onConfirm () {
if(!window.location.href.includes('loginPage')) {
router.push({
name: 'Entry',
})
setLocalValue('nonetwork', true)
}
},
})
})
window.addEventListener('online', () => {
console.log('网络已连接')
this.network = true
setLocalValue('nonetwork', false)

})
},
methods: {
matchRoute (name) {
let index = name.lastIndexOf('_')
let str0 = name.substring(0, index)
let str = name.substring(index + 1, name.length)
switch (str) {
case 'list':
return `${str0}List`
case 'detail':
return `${str0}Detail`
case 'edit':
return `${str0}Edit`
case 'new':
return `${str0}New`
default:
return name
}
},
},
}










// WEBPACK FOOTER //
// ./src/App.vue